import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ICustomFieldValueInput } from "../../@types/CustomField";
import { customFieldsService } from "../../services/customFieldsService";
import { ensureOk } from "../../utils/ensureOk";

// EN-5067: partial-upsert a patient's side-panel custom-field values (PUT). Mirrors
// useSetPatientWards: invalidates the patient's custom-field query and the patient-list caches
// (custom columns read the same values).
export function useSetPatientCustomFields() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({
      patientId,
      customFields,
    }: {
      patientId: number;
      customFields: ICustomFieldValueInput[];
    }) =>
      ensureOk(
        await customFieldsService.setPatientCustomFields(patientId, {
          customFields,
        })
      ),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["patient-custom-fields", variables.patientId],
      });
      queryClient.invalidateQueries({ queryKey: ["patient-list-active"] });
      queryClient.invalidateQueries({ queryKey: ["patient-list-flagged"] });
      queryClient.invalidateQueries({ queryKey: ["patient-list-alerts"] });
      queryClient.invalidateQueries({ queryKey: ["patient-list-archived"] });
    },
  });

  return { mutateAsync, isPending };
}
